import {
  Box,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { FaChevronDown, FaLayerGroup } from "react-icons/fa";

const GroupByFilter = ({
  currentGroupByOptions,
  handleApplyFilters,
  filters,
  isRTL,
}) => {
  const currentGroupOption = currentGroupByOptions.find(
    (option) => option.value === filters.groupBy
  );
  return (
    <Box h="full">
      <Menu>
        <MenuButton
          w="full"
          variant="outline"
          size="sm"
          textAlign={isRTL ? "right" : "left"}
          h="40px"
          display="flex"
          alignItems="center"
        >
          <HStack
            spacing={1}
            w="full"
            justify={isRTL ? "flex-end" : "flex-start"}
          >
            {isRTL && <Icon as={FaChevronDown} />}
            <Icon as={FaLayerGroup} color="teal.500" />
            <Text noOfLines={1} flex={1}>
              {currentGroupOption?.label ||
                (isRTL ? "اختر التجميع" : "Select grouping")}
            </Text>
            {!isRTL && <Icon as={FaChevronDown} />}
          </HStack>
        </MenuButton>
        <MenuList maxH="300px" overflowY="auto" minW="200px">
          {currentGroupByOptions.map((option) => (
            <MenuItem
              key={option.value}
              onClick={() => handleApplyFilters({ groupBy: option.value })}
              fontWeight={option.value === filters.groupBy ? "bold" : "normal"}
              bg={option.value === filters.groupBy ? "blue.50" : "white"}
              textAlign={isRTL ? "right" : "left"}
            >
              {option.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};
export default GroupByFilter;
